import {createSlice} from '@reduxjs/toolkit';
import {USER_LOCALSTORAGE_KEY, USER_SUCCESS_KEY} from "shared/const/localstorage";
import {UserSchema} from "entities/User/model/types/user";


const initialState: UserSchema = {};

export const logoutSlice = createSlice({
    name: 'logout',
    initialState,
    reducers: {
        logout: (state) => {
            state.authData = undefined;
            localStorage.removeItem(USER_LOCALSTORAGE_KEY);
            localStorage.removeItem(USER_SUCCESS_KEY);
        },
    },
});


export const {actions: logoutActions} = logoutSlice;
export const {reducer: logoutReducer} = logoutSlice;
